import { BANNER_ASSOCIATION_ID_TYPES, BANNER_DISPLAY_EVERYWHERE_ID, PULSE_SURVEY_NOTIFICATION_PREFERENCE_TYPE, GROUP_PULSE_SURVEY_NOTIFICATION_PREFERENCE_TYPE } from "src/constants/AppConstants"
import { listPreference, listPreferenceByPreferenceType } from "../../utilities/AppSyncPlusAPIs"
import { PulseSurveyNotification, PulseSurveyNotificationFromPreference, PulseSurveyNotificationAssociationId, PreferenceByTypeSuccessResponse, PreferenceSuccessResponse } from "./PulseSurveyNotificationTypes"

const getSurveyNotificationsByPreferenceType = (preferenceType: string): Promise<PulseSurveyNotification[]> => {
    return new Promise((resolve, reject) => {
        listPreferenceByPreferenceType(preferenceType,
            (successResponse: PreferenceByTypeSuccessResponse) => {
                const items = successResponse?.data?.listPreferenceByPreferenceType?.items
                if (items) {
                    const surveys = items.map((item: PulseSurveyNotificationFromPreference) => {
                        return {
                            ...item,
                            information: JSON.parse(item.information)
                        }
                    })
                    resolve(surveys)
                } else {
                    resolve([])
                }
            },
            (errorResponse: string) => {
                reject(errorResponse)
            }
        )
    })
}

const getSurveyNotifications = (associationId: PulseSurveyNotificationAssociationId, associationIdType: string): Promise<PulseSurveyNotification[]> => {
    return new Promise((resolve, reject) => {
        listPreference(associationId, associationIdType, PULSE_SURVEY_NOTIFICATION_PREFERENCE_TYPE,
            (successResponse: PreferenceSuccessResponse) => {
                const items = successResponse?.data?.listPreference?.items
                if (items) {
                    const surveyNotifications = items.map((item: PulseSurveyNotificationFromPreference) => {
                        return {
                            ...item,
                            information: JSON.parse(item.information)
                        }
                    })
                    resolve(surveyNotifications)
                } else {
                    resolve([])
                }
            },
            (errorResponse: string) => {
                reject(errorResponse)
            }
        )
    })
}

export const getSingleSurveyNotifications = async (): Promise<PulseSurveyNotification[]> => {
    return await getSurveyNotificationsByPreferenceType(PULSE_SURVEY_NOTIFICATION_PREFERENCE_TYPE)
}

export const getGroupSurveyNotifications = async (): Promise<PulseSurveyNotification[]> => {
    return await getSurveyNotificationsByPreferenceType(GROUP_PULSE_SURVEY_NOTIFICATION_PREFERENCE_TYPE)
}

export const getDisplayEverywhereSurveyNotifications = async (): Promise<PulseSurveyNotification[]> => {
    return await getSurveyNotifications(BANNER_DISPLAY_EVERYWHERE_ID, BANNER_ASSOCIATION_ID_TYPES.ABC)
}

export const getClosePortalSurveyNotifications = async (closePortalOwnerId: PulseSurveyNotificationAssociationId): Promise<PulseSurveyNotification[]> => {
    return await getSurveyNotifications(closePortalOwnerId, BANNER_ASSOCIATION_ID_TYPES.CLOSE_PORTAL)
}

export const getEverywhereClosePortalSurveyNotifications = async (): Promise<PulseSurveyNotification[]> => {
    return await getClosePortalSurveyNotifications(BANNER_DISPLAY_EVERYWHERE_ID)
}

export const getUrlPrefixSurveyNotifications = async (urlPrefix: PulseSurveyNotificationAssociationId): Promise<PulseSurveyNotification[]> => {
    return await getSurveyNotifications(urlPrefix, BANNER_ASSOCIATION_ID_TYPES.URL_PREFIX)
}

export const getAppSurveyNotifications = async (appId: PulseSurveyNotificationAssociationId): Promise<PulseSurveyNotification[]> => {
    return await getSurveyNotifications(appId, BANNER_ASSOCIATION_ID_TYPES.APP)
}

export const getEverywhereAppSurveyNotifications = async (): Promise<PulseSurveyNotification[]> => {
    return await getAppSurveyNotifications(BANNER_DISPLAY_EVERYWHERE_ID)
}

export const getTriggerSurveyNotifications = async (actionTriggerType: string): Promise<PulseSurveyNotification[]> => {
    // Get all single survey notifications and filter by action trigger type
    const allNotifications = await getSurveyNotificationsByPreferenceType(PULSE_SURVEY_NOTIFICATION_PREFERENCE_TYPE);
    return allNotifications.filter(notification => notification.information?.actionTrigger === actionTriggerType);
}
